export class UserDto {
    Id?: number;
    Name?: string;
    Username?: string;
    Password?: string;
    RePassword?:string;
    Email?: string;
    email?: string;
    Cellphone?: string;
    IsCellphoneVerified?: boolean;
    Birthdate?: string;
    Credit?: number;
    JobTitle?: string;
    About?: string;
    SendEmail?: boolean;
    SendMessage?: boolean;
    Links?: string;
    DefaultAddressId?: number;
    DefaultAccountId?: number;
    IsActive?: boolean;
    // DefaultAddress?: DefaultAddress;
    // DefaultAccount?: DefaultAccount;
    CreatorUserId?: number;
    CreationTime?: string;
    LastModifierUserId?: number;
    LastModificationTime?: string;
    DeleterUserId?: number;
    DeletionTime?: string;
    IsDeleted?: boolean;
}
